module.exports =(function() {
  return function(context) {
    return (function() {
      var $o;
      $o = [];
      $o.push("<div class='component-notification__icon'></div>\n<div class='component-notification__flex-container'>\n  <div class='component-notification__message'></div>\n  <div class='component-notification__actions'>\n    <button class='component-notification__action' name='primary'></button>\n    <button class='component-notification__action' name='dismiss' title='Dismiss'></button>\n  </div>\n</div>");
      return $o.join("\n").replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);
